import styled from 'styled-components'

export const ActionsContainer = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  margin-top: ${props => props.theme.spacing.sp16};
`

export const AlertContainer = styled.div`
  margin-top: ${props => props.theme.spacing.sp32};
`

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
